import { createClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

// Initialize Sanity client
export const client = createClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID || "",
  dataset: process.env.REACT_APP_SANITY_DATASET || "production",
  useCdn: true, // Use CDN for faster response
  apiVersion: "2024-03-21", // Use current date
});

// Helper function to generate image URLs
const builder = imageUrlBuilder(client);

export const urlFor = (source) => {
  return builder.image(source);
};

// Fetch all news/events from Sanity
export const getNews = async () => {
  try {
    const query = `*[_type == "news"] | order(date desc) {
      _id,
      title,
      date,
      category,
      description,
      image,
      featured
    }`;

    const news = await client.fetch(query);
    return news;
  } catch (error) {
    console.error("Error fetching news from Sanity:", error);
    return null;
  }
};

// Fetch single news item by ID
export const getNewsById = async (id) => {
  try {
    const query = `*[_type == "news" && _id == $id][0] {
      _id,
      title,
      date,
      category,
      description,
      image,
      featured
    }`;

    const newsItem = await client.fetch(query, { id });
    return newsItem;
  } catch (error) {
    console.error("Error fetching news item:", error);
    return null;
  }
};
